/* unplugin-vue-components disabled */import { render } from "./SeesawQuestionView.vue?vue&type=template&id=2f587f89&scoped=true"
import script from "./SeesawQuestionView.vue?vue&type=script&lang=js"
export * from "./SeesawQuestionView.vue?vue&type=script&lang=js"

import "./SeesawQuestionView.vue?vue&type=style&index=0&id=2f587f89&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f587f89"]])

export default __exports__